import { FormFieldList, SfToggleFormField } from 'ngx-smart-form';
import { FormField } from 'ngx-smart-form/lib/smart-form/classes/form-field';
import { CheckedValidator } from '../../_core/validators/checked-validator';
import { Impresa } from '../models/impresa';
import { PersonaGiuridica } from '../models/persona-giuridica';

export const getConsentFields = (applicant?: Impresa) => {
  const consentFields: FormFieldList<Impresa> = [
    [
      new SfToggleFormField({
        formControlName: 'privacy1',
        label: 'Per esigenze di profilazione',
        validators: [CheckedValidator],
      }),
    ],
    [
      new SfToggleFormField({
        formControlName: 'privacy2',
        label:
          'Per decisioni bassate unicamente su uno o più trattamenti automatizzati',
        validators: [CheckedValidator],
      }),
    ],
    [
      new SfToggleFormField({
        formControlName: 'privacy3',
        label:
          'Per la promozione e la vendita di prodotti e servizi, effettuate attraverso le modalità indicate',
        validators: [CheckedValidator],
      }),
    ],
    [
      new SfToggleFormField({
        formControlName: 'privacy4',
        label:
          'Per la cessione dei miei dati personali ad altre società, aziende di ricerca e società di consulenza per loro autonomi trattamenti con finalità di marketing',
        validators: [CheckedValidator],
      }),
    ],
  ];
  consentFields.forEach((row) =>
    row.forEach(
      (field) => (field.value = applicant?.[field.formControlName] || false)
    )
  );
  return consentFields;
};
